<script lang="ts">
	import logo from "../../../../core/assets/logo.svg";
	import type { UploadedFile } from "../../../../core/schema/UploadedFile.js";
	import type { Image } from "../../../../core/schema/Image.js";
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import { appName } from "../../../../core/schema/names/appName.js";
	import type { Position } from "../../../../core/schema/Position.js";
	import translations from "./CareerDesktopGallery.translations.json";
	import { getSharedTranslate } from "../../utils/getSharedTranslate.js";

	export let position: Position;
	export let images: Image[];
	export let containerClass = "";
	export { containerClass as class };

	const [primaryImage, ...otherImages] = images;

	let displayedImage: UploadedFile | undefined = primaryImage;

	function displayImage(image: Image): void {
		displayedImage = image;
	}

	const translate = getSharedTranslate(translations);

	const imageWidth = 600;

	function displayPrimaryImage(): void {
		displayedImage = primaryImage;
	}

	// eslint-disable-next-line no-warning-comments
	// FIXME remove this after upgrade to Svelte 5.
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<div class="relative rounded-lg bg-gray-300 p-8 {containerClass}">
	{#if displayedImage}
		<DynamicPicture
			class="aspect-square h-full w-full rounded-lg bg-transparent md:max-h-[30.5rem]"
			imgClass="w-full h-full rounded-lg aspect-square object-cover"
			image={displayedImage}
			lightboxId={position.name}
			lightboxWidth={800}
			width={imageWidth}
			height={imageWidth}
			bucket="storage"
			loading="eager"
			alt="{translate('photo')} – {position.name} (1/{images.length})"
		/>
	{:else}
		<div
			class="bg-secondaryBlack-40 flex aspect-square h-full w-full items-center justify-center rounded-lg bg-white p-4 md:max-h-[40.5rem]"
		>
			<StaticPicture
				alt="Logo {appName}"
				image={logo}
				class="w-28 opacity-50 lg:w-36 xl:w-40"
				loading="eager"
				width={160}
				height={160}
			/>
		</div>
	{/if}
	<div class="mt-4 grid grid-flow-row grid-cols-11 gap-2">
		{#each otherImages as image, i}
			<DynamicPicture
				class="aspect-square h-full max-h-[8.5rem] w-full max-w-[8.5rem] rounded-lg bg-white transition-transform duration-300 hover:scale-105 xl:p-1"
				imgClass="w-full h-full rounded-lg object-cover"
				{image}
				lightboxId={position.name}
				lightboxWidth={800}
				width={imageWidth}
				height={imageWidth}
				bucket="storage"
				loading="eager"
				alt="{translate('photo')} – {position.name} ({i + 2}/{images.length})"
				on:mouseover={() => {
					displayImage(image);
				}}
				on:mouseout={displayPrimaryImage}
			/>
		{/each}
	</div>
</div>
